<h2 mat-dialog-title>{{imageType==="landscape" ? 'Landscape' : 'Square'}} Image</h2>
<mat-dialog-content class="mat-typography">
    <div class="image-wrapper">
        <img [src]="imageUrl" alt="program-image">
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-button mat-dialog-close>Cancel</button> -->
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>
